import {Charts} from './lib/Chart/Charts';
import {Calendar} from './lib/Calendar/createCalendar';
import {TopPanel} from './TopPanel';
import '../css/main.css';


//import menu
TopPanel();

//create charts
Charts();

//create calendar and map events to it
Calendar()

